import { render, staticRenderFns } from "./LocationView.vue?vue&type=template&id=36827322&"
import script from "./LocationView.vue?vue&type=script&lang=js&"
export * from "./LocationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports